module.exports = __webpack_public_path__ + "images/Levi`s-f27eae.png";